import { render, staticRenderFns } from "./EditPartnerLanguageModal.vue?vue&type=template&id=59d78be6&"
import script from "./EditPartnerLanguageModal.vue?vue&type=script&lang=js&"
export * from "./EditPartnerLanguageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports